export default __webpack_public_path__ + "static/SOC2-696eeb961dbac0df5811a2e09adb87cd.png";